import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HtmlBase, PropertyData, QueovalItemModel, BlockTree } from '../../../../models';
import { BaseAddOnComponent } from '../base-addon.component';
import { HttpService, CoreService } from '../../../../services';
import { b64EncodeUnicode } from '../../../../utilities';

@Component({
  selector: 'q-ackkey',
  templateUrl: './ackkey.component.html',
  styleUrls: ['./ackkey.component.css']
})

export class AckkeyComponent extends BaseAddOnComponent implements OnInit {
  private selectedUsers: string[] = [];

  showList: boolean = false;
  usersList: Array<BlockTree> = [];
  allChecked: boolean = false;

  @Input('input') input: PropertyData;
  @Output() inputChange: EventEmitter<PropertyData> = new EventEmitter<PropertyData>(false);
  constructor(
    private http: HttpService,
    private indParam: CoreService
  ) { super(); }

  ngOnInit(): void { }

  openTree(): void {
    if (this.input.MainElementList[0].Disabled)
      return;

    this.indParam.showSplash(true);
    const vl: string = this.input.MainElementList[0].Value !== '' ? b64EncodeUnicode(this.input.MainElementList[0].Value) : '0';
    this.http.getHttp<QueovalItemModel>(`${this.indParam.AppParams.apiUrl}api/queovalitem/getData/ACKKEY/${vl}`).subscribe((result: QueovalItemModel) => {
      if (!result.HasError) {
        this.usersList = result.UsersBlock.Children;
        if (this.input.MainElementList[0].Value === '' || this.input.MainElementList[0].Value === '|0|') {
          this.checkAll();
        }
        this.showList = true;
      }
      this.indParam.showSplash(false);
    });
  }

  close(): void {
    this.showList = false;
  }

  save(): void {
    this.selectedUsers = [];
    for (const group of this.usersList) {
      if (group.IsAllowed) {
        for (const user of group.Children) {
          if (user.IsChecked) {
            if (this.selectedUsers.indexOf(user.Value) === -1)
              this.selectedUsers.push(user.Value);
          }
        }
      }
    }
    if (this.selectedUsers.length === this.countUsers()) {
      // all of the users are selected = > the property is visible for all
      this.input.MainElementList[0].Value = `|0|`;
    }
    else if (this.selectedUsers.length === 0) {
      // there are not selected users = > the property is not visible for all
      this.input.MainElementList[0].Value = `|-0|`;
    }
    else {
      // some users are selected => the property is not visible for all except the selected ones
      this.input.MainElementList[0].Value = `|-0|${this.selectedUsers.join('|')}|`;
    }
    this.showList = false;
    this.inputChange.emit(this.input);
  }

  checkOffice(office: BlockTree): void {
    const isCK: boolean = office.IsChecked = !office.IsChecked;
    this.checkList(office.Children, isCK);
    for (const u of office.Children) {
      this.fixUsers(isCK, u.Value);
    }
  }

  showUsers(office: BlockTree, event: any): void {
    event.preventDefault();
    office.CollapseMode = office.CollapseMode === 1 ? 2 : 1;
    for (let n: number = 0; n < office.Children.length; n++) {
      const user: BlockTree = office.Children[n];
      user.IsVisible = user.IsVisible
        ? false
        : user.IsAllowed ? true : false;
    }
  }

  checkUser(user: BlockTree, group: BlockTree): void {
    user.IsChecked = !user.IsChecked;
    if (user.IsChecked) {
      group.IsChecked = true;
    }
    else {
      const groupSelectedUsers: BlockTree[] = group.Children.filter((usr: BlockTree) => usr.IsAllowed && usr.IsChecked);
      group.IsChecked = groupSelectedUsers.length > 0;
    }
    this.fixUsers(user.IsChecked, user.Value);
  }

  checkAll(): void {
    const isCK: boolean = this.allChecked = !this.allChecked;
    for (const group of this.usersList) {
      group.IsChecked = isCK;
      for (const user of group.Children) {
        user.IsChecked = isCK;
        user.IsVisible = isCK;
      }
    }
  }

  private checkList(list: BlockTree[], isChecked: boolean): void {
    if (list) {
      for (let n: number = 0; n < list.length; n++) {
        if (list[n].IsAllowed) {
          list[n].IsChecked = isChecked;
          if (list[n].Children) {
            list[n].Children.forEach((el: BlockTree) => {
              if (el.IsAllowed)
                el.IsVisible = isChecked;
            });
          }
        }
        this.checkList(list[n].Children, isChecked);
      }
    }
  }

  private fixUsers(isCheck: boolean, value: string): void {
    for (const group of this.usersList) {
      if (group.IsAllowed) {
        for (const user of group.Children) {
          if (user.Value === value && user.IsAllowed) {
            user.IsChecked = isCheck;
          }
        }

        // if just one user of the group is checked => the group is checked
        const groupSelectedUsers: BlockTree[] = group.Children.filter((user: BlockTree) => user.IsAllowed && user.IsChecked);
        group.IsChecked = groupSelectedUsers.length > 0;
        // if the group is checked its users are displayed
        if (group.IsChecked) {
          group.Children.forEach((c: BlockTree) => { if (c.IsAllowed) c.IsVisible = true; });
        }
      }
    }
  }

  private countUsers(): number {
    const us: string[] = [];
    for (const group of this.usersList) {
      if (group.IsAllowed) {
        for (const user of group.Children) {
          if (us.indexOf(user.Value) === - 1)
            us.push(user.Value);
        }
      }
    }
    return us.length;
  }

  //navig(button: HtmlBase, value: string): void {
  //  const params: Array<QueovalItem> = button.OnClickParams;
  //  for (const param of params) {
  //    if (param.Value === button.Code) {
  //      param.Text = value;
  //    }
  //  }
  //  if (params.length > 0) {
  //    button.OnClick = `${button.OnClick}?${params[0].Value}=${params[0].Text}`;
  //    if (params.length > 1) {
  //      for (let i: number = 1; i < params.length; i++) {
  //        button.OnClick += `&${params[i].Value}=${params[i].Text}`;
  //      }
  //    }
  //  }
  //  this.setInput.emit(button);
  //}
}
